import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import Layout from '@/components/main-layout'
import { useAuth } from '@/context'

function LoadingSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="border-primary h-12 w-12 animate-spin rounded-full border-b-2"></div>
    </div>
  )
}

function AuthenticatedLayout() {
  const { user, loading } = useAuth()
  
  if (loading) {
    return <LoadingSpinner />
  }
  
  if (!user) {
    throw redirect({ to: '/auth' })
  }
  
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})